  export const pushValidationError = (
    q: any,
    message: string,
    type: string,
    ref:any
  ) => {
    const exists = ref.current.some(
      (e:any) =>
        e.questionName === q.name &&
        e.validatorType === type
    );

    if (exists) return;

    ref.current.push({
      questionName: q.name,
      questionTitle: q.title || q.name,
      message,
      validatorType: type,
    });
  };


  export function formatDateTime(datetimeString:any) {
  const date = new Date(datetimeString);

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";

  hours = hours % 12;
  hours = hours ? hours : 12;
  const hoursStr = String(hours).padStart(2, "0");

  return `${day}-${month}-${year} ${hoursStr}:${minutes} ${ampm}`;
}

export function formatDateTimeIST(datetimeString: any) {
  const date = new Date(datetimeString + "z");

  // Convert to IST using locale
  const istDate = new Date(
    date.toLocaleString("en-US", { timeZone: "Asia/Kolkata" })
  );

  const day = String(istDate.getDate()).padStart(2, "0");
  const month = String(istDate.getMonth() + 1).padStart(2, "0");
  const year = istDate.getFullYear();

  let hours = istDate.getHours();
  const minutes = String(istDate.getMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";

  hours = hours % 12;
  hours = hours ? hours : 12;

  const hoursStr = String(hours).padStart(2, "0");

  return `${day}-${month}-${year} ${hoursStr}:${minutes} ${ampm}`;
}